module.exports = __webpack_public_path__ + "assets/img/202112-3.2d96e6bc.png";